import getAdvertiser from "@/services/api/advertiserServiceApi";

let pendingRequest = null;

const advertiserModule = {
  namespaced: true,
  state() {
    return {
      list: null,
    };
  },
  mutations: {
    setResult(state, result) {
      state.list = result;
    },
  },
  actions: {
    async getAdvertiser({ state, commit }, key) {
      if (state.list?.company?.slug === key) {
        return state.list;
      }

      if (pendingRequest) {
        return pendingRequest;
      }

      pendingRequest = getAdvertiser(key)
        .then((response) => {
          commit("setResult", response);
          return response;
        })
        .finally(() => {
          pendingRequest = null;
        });

      return pendingRequest;
    },
  },
};

export default advertiserModule;
